import { axiosInstance } from "../../../helper"
import { sacrament } from "../types"

export function getMatrimonial(params, config) {
	return {
		type: sacrament.GET_MATRIMONY,
		payload: new axiosInstance.get("/admin/sacrament/matrimony", {
			...config,
			params,
		}),
	}
}

export default getMatrimonial
